import Alpine from "alpinejs";

Alpine.data("carousel", (id, autoScrollInterval = null) => {
  return {
    id: id,
    autoScrollInterval: autoScrollInterval,
    autoScrollTimer: null,
    get container() {
      return this.$el;
    },
    init() {
      this.setupEventListeners();

      if (this.autoScrollInterval && this.container.children.length > 0) {
        this.setupAutoScroll();
      }
    },
    setupAutoScroll() {
      this.startAutoScroll();

      this.container.addEventListener("scroll", () => {
        this.stopAutoScroll();
        this.startAutoScroll();
      });
    },
    setupEventListeners() {
      window.addEventListener(`scroll-carousel:${this.id}:next`, () => {
        this.scrollNext();
      });
      window.addEventListener(`scroll-carousel:${this.id}:previous`, () => {
        this.scrollPrevious();
      });
      window.addEventListener(`scroll-carousel:${this.id}:start`, () => {
        this.scrollTo(0);
      });
      window.addEventListener(`scroll-carousel:${this.id}:to`, (event) => {
        this.scrollTo(event.detail.index);
      });
    },
    scrollNext() {
      const { scrollLeft, scrollWidth, offsetWidth } = this.container;
      const isAtEnd = ((scrollLeft + offsetWidth) >= (scrollWidth - 10));

      this.container._scrollBy({
        left: isAtEnd ? -this.container.scrollLeft : this.container.offsetWidth,
        behavior: "smooth",
      });
    },
    scrollPrevious() {
      this.container._scrollBy({
        left: -this.container.offsetWidth,
        behavior: "smooth",
      });
    },
    scrollTo(index) {
      const child = this.container.children[index];

      if (child) {
        this.container.scrollTo({
          left: index === 0 ? 0 : (
            this.container.scrollLeft + 
            (child.getBoundingClientRect().left - this.container.getBoundingClientRect().left)
          ),
          behavior: 'smooth',
        });
      }
    },
    startAutoScroll() {
      this.autoScrollTimer = setInterval(() => {
        this.scrollNext();
      }, this.autoScrollInterval);
    },
    stopAutoScroll() {
      if (this.autoScrollTimer) {
        clearInterval(this.autoScrollTimer);
        
        this.autoScrollTimer = null;
      }
    },
  };
});
